import script from "./AnnualExpenses.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnnualExpenses.vue?vue&type=script&setup=true&lang=ts"

import "./AnnualExpenses.vue?vue&type=style&index=0&id=c2ebd304&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2ebd304"]])

export default __exports__